import { HttpApiEndpoint, HttpApiGroup } from "@effect/platform";
import { Context } from "effect";
import { Schema as S } from "effect";
export const SessionTokens = S.Struct({
    access_token: S.String,
    refresh_token: S.String,
    expires: S.Number,
});
export const SessionTokensSuccess = S.Struct({ data: SessionTokens });
const failure = { code: S.String, message: S.String };
export const SessionTokenRefreshFailure = S.Struct({
    ...failure,
    status: S.Literal(400),
});
export const SessionTokenRefreshUnauthorized = S.Struct({
    ...failure,
    status: S.Literal(401),
});
export const SessionTokenRefreshForbidden = S.Struct({
    ...failure,
    status: S.Literal(403),
});
export const SessionTokenRefreshError = S.Union(SessionTokenRefreshFailure, SessionTokenRefreshUnauthorized, SessionTokenRefreshForbidden);
/**
 * Public token rotation: the refresh token itself authorizes the exchange, so
 * the group carries no principal middleware and an anonymous request reaches
 * it through the /web/v1 bridge.
 */
export const sessionTokensGroup = HttpApiGroup.make("sessionTokens").add(HttpApiEndpoint.post("refresh", "/auth/token/refresh")
    .setPayload(S.Struct({ refresh_token: S.NonEmptyString }))
    .addSuccess(SessionTokensSuccess)
    .addError(SessionTokenRefreshFailure, { status: 400 })
    .addError(SessionTokenRefreshUnauthorized, { status: 401 })
    .addError(SessionTokenRefreshForbidden, { status: 403 }));
export class SessionTokenRefresher extends Context.Tag("@pima/web-api/SessionTokenRefresher")() {
}
//# sourceMappingURL=session-tokens.js.map